



import NewsListComponent from "@/components/admin/news/newsListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "NewsListPage",
  components: {
    NewsListComponent,
  },
})
export default class NewsListPage extends Vue {}
